import { BreadcrumbItemType } from '@/components/breadcrumbs/Breadcrumbs';
import { useEffect } from 'react';
import { create } from 'zustand';

type BreadcrumbsStore = {
  breadcrumbItems: BreadcrumbItemType[] | undefined;
  setBreadcrumbItems: (breadcrumbItems: BreadcrumbItemType[] | undefined) => void;
};

export const useBreadcrumbsStore = create<BreadcrumbsStore>()((set) => ({
  breadcrumbItems: undefined,
  setBreadcrumbItems: (breadcrumbItems) => set((oldState) => ({ ...oldState, breadcrumbItems })),
}));

export function useSetBreadcrumbsOnMount(breadcrumbItems: BreadcrumbItemType[]) {
  const { setBreadcrumbItems } = useBreadcrumbsStore();

  useEffect(
    function setBreadcrumbsOnMount() {
      setBreadcrumbItems(breadcrumbItems);

      return function clearBreadcrumbsOnUnmount() {
        setBreadcrumbItems(undefined);
      };
    },
    [breadcrumbItems, setBreadcrumbItems],
  );
}
